/** Delivery metadata from prebuilt catalog (nested `delivery`) or localStorage. */

export const EMPTY_DELIVERY = {
    delivery_availabilities: [],
    delivery_fees: [],
    delivery_periods: [],
};

function asObject(value) {
    return value && typeof value === "object" && !Array.isArray(value) ? value : {};
}

function pickList(source, nested, fallback, fallbackNested, key) {
    const candidates = [source[key], nested[key], fallback[key], fallbackNested[key]];
    const nonEmpty = candidates.find((item) => Array.isArray(item) && item.length > 0);
    if (nonEmpty) {
        return nonEmpty;
    }
    const firstArray = candidates.find((item) => Array.isArray(item));
    return firstArray || [];
}

/**
 * Normalize delivery fees/periods from catalog bootstrap, IDB `_delivery`, or localStorage.
 * Prebuilt catalog nests these under `delivery`; Odoo `get_products_data` sends them top-level.
 */
export function extractDeliveryMeta(source, fallback = {}) {
    const src = asObject(source);
    const nested = asObject(src.delivery);
    const fb = asObject(fallback);
    const fbNested = asObject(fb.delivery);
    return {
        delivery_availabilities: pickList(src, nested, fb, fbNested, "delivery_availabilities"),
        delivery_fees: pickList(src, nested, fb, fbNested, "delivery_fees"),
        delivery_periods: pickList(src, nested, fb, fbNested, "delivery_periods"),
    };
}

export function hasDeliveryPeriods(delivery) {
    return Array.isArray(delivery?.delivery_periods) && delivery.delivery_periods.length > 0;
}

/** Map Odoo period ids (number or string) onto catalog period rows. */
export function mapAvailablePeriods(deliveryPeriods, availableIds) {
    const ids = new Set((availableIds || []).map((id) => Number(id)).filter((id) => !Number.isNaN(id)));
    return (deliveryPeriods || []).filter((period) => ids.has(Number(period?.id)));
}
